// Need to merge with the one in protocol
export enum SCORE_TREATMENT {
    NOT_FINISHED = 0,
    NORMAL = 1,
    CANCELLED = 2,
    ARTIFICIAL = 3,
    REPLACEMENT = 4 // new in 3.1.8. Must be calculated like SCORE_TREATMENT_NORMAL.
};

export enum MOVEMENT_ACTION {
    SILENT = 0,  // Server side only
    JOIN_CLUB = 1, // special interpretation: this user logged on
    LEAVE_CLUB = 2, // special interpretation: this user logged off
    SERVE_TABLE = 3,
    JOIN_TABLE = 4,
    LEAVE_TABLE = 5,
    SIT = 6,
    JOIN_ACTIVITY = 7,
    LEAVE_ACTIVITY = 8,
}

export enum MOVEMENT_CAUSE {
    NORMAL = 0,
    CLOSE_NO_PLAYERS = 1,
    CLOSE_BY_SERVER = 2,
    REMOVAL_BY_HOST = 3,
    TIMEOUT = 4,
    LOST_CONNECTION = 5,
    TABLE_DELEGATION = 6,
    SEAT_ASSIGNMENT = 7,
    TIMEOUT_CAROUSEL = 8,
}

export enum HasBots {
    None = 0,
    Recreational = 1,
    Competition = 2,
}

export const ciViewTableUsersSourceIsTablesForm = 7;
export const ciViewTableUsersSourceIsMainForm = 8;

export class FilterViewTables {
    static readonly TABLE_FILTER_SCORING_METHOD = 1;
    static readonly TABLE_FILTER_COMPLETE_TABLE = 2;
    static readonly TABLE_FILTER_IN_USER_LEVEL_RANGE = 3;

    parameter = 0;
    value = 0;

    setScoringMethod(sm: number) {
        this.parameter = FilterViewTables.TABLE_FILTER_SCORING_METHOD;
        this.value = sm;
    }

    setCompleteTable(complete: boolean) {
        this.parameter = FilterViewTables.TABLE_FILTER_COMPLETE_TABLE;
        this.value = complete ? 1 : 0;
    }

    setUserLevelRange(inrange: boolean) {
        this.parameter = FilterViewTables.TABLE_FILTER_IN_USER_LEVEL_RANGE;
        this.value = inrange ? 1 : 0;
    }
}

export const UNDO = {
    MSG_NONE: 0,
    BID_UNDONE: 1,
    PLAY_UNDONE: 2,
} as const;
